<ng-container *transloco="let t;">
    <ng-container *ngIf="sendSmsPin; else verifiyandsign">
        <div class="container email-and-SMS-pin-container">
            <div class="row">
                <div class="col-lg-12 col-12">
                    <div class="email-and-SMS-pin-box-header border-bottom mb-1 pt-0">
                        <h2> {{ t("Email and SMS pin heading text - (Email and SMS pin box) - Sign with PIN by SMS") }}</h2>
                    </div>
                    <div class="email-and-SMS-pin-box-content">
                        <p class="email-and-SMS-pin-box-title"> {{ t("Email and SMS pin box title text - (Email and SMS pin box) - Please enter your PIN") }} <strong>{{roleDetail.recipient?.phone_no}}</strong></p>
                        <button [disabled]="sendSmsPinLoading" type="button" class="btn btn-success email-and-SMS-pin-box-button" (click)="sendPin()">
                            {{t("Email and SMS pin box button text - (Email and SMS pin box) - Send SMS")}} <span *ngIf="sendSmsPinLoading" class="spinner-border spinner-border-sm me-1 roleButtonloader"></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-template #verifiyandsign>
        <div class="container SMS-enter-pin-container">
            <div class="row">
                <div class="col-lg-12 col-12">
                    <div class="SMS-enter-pin-box-header border-bottom mb-1 pt-0">
                        <h2> {{ t("Email and SMS pin heading text - (Email and SMS pin box) - Sign") }}</h2>
                    </div>
                    <form [formGroup]="pinForm">
                        <div class="SMS-enter-pin-box-content d-flex">
                            <div class="SMS-enter-pin-box-content-left">
                                <div class="col-xl-12 col-md-12 col-12 ps-0 mb-1">
                                    <div class="form-group">
                                        <label for="pin">{{ t("SMS pin box description text - (Email and SMS pin box) - Check your phone") }}</label>
                                        <input type="text" class="form-control" id="pin" [placeholder]="t('SMS pin box description text - (Email and SMS pin box) - Enter your pin')" formControlName="pin" [ngClass]="{ 'is-invalid error': pinFormSubmitted && pinForm.controls.pin.errors }"/>
                                    </div>
                                </div>
                            </div>
                            <div class="SMS-enter-pin-box-content-right border-start">
                                <p class="SMS-enter-pin-box-title px-1" [innerHTML]='t("SMS pin box description text - (Email and SMS pin box) - recipient by clicking the button you will sign the document and your signature will be registered by the e-signing service Simple Sign", {recipient : roleDetail.recipient.firstname +" "+ (roleDetail.recipient?.lastname ?? ""), document_name: roleDetail?.roleable?.visible_name ?? roleDetail?.roleable?.name})'></p>
                            </div>
                            
                        </div>
                        <div class="SMS-enter-pin-box-content-buttons d-flex justify-content-between mt-1 align-items-center border-top pt-1">
                            <button type="button" class="btn btn-outline-secondary" (click)="backToTheSendSms()" rippleEffect>{{t("Back button text (back button) - back")}}</button>
                            <button [disabled]="pinFormLoading" type="submit" class="btn btn-primary w-50 btn-block" (click)="verifyPin()">
                                {{t("Email and SMS pin heading text - (Email and SMS pin box) - Sign")}} <span *ngIf="pinFormLoading" class="spinner-border spinner-border-sm me-1 roleButtonloader"></span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </ng-template>
</ng-container>